import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { VenueSlider } from '../components/VenueSlider';

export const LandingPage: React.FC = () => {
  const handleMenuClick = () => {
    // Menu click handler
  };

  const handleAboutClick = () => {
    // About click handler
  };

  const handleContactClick = () => {
    // Contact click handler
  };

  return (
    <div className="min-h-screen bg-[#20232c]">
      <Header 
        onMenuClick={handleMenuClick}
        onAboutClick={handleAboutClick}
        onContactClick={handleContactClick}
      />
      <Hero />
      <VenueSlider />
    </div>
  );
};